import { SidebarModal } from '@domain-group/suit-theme'

import useOrderItemTask from '@hooks/useOrderItemTask'

import TaskIcon from '@components/TaskIcon'

import type { OrderItemModel, OrderItemTaskTypeModel } from '@models/types'

interface NewTaskProps {
  orderItem: OrderItemModel,
  taskType: OrderItemTaskTypeModel,
}

const NewTask = (props: NewTaskProps) => {
  const { taskType, orderItem } = props
  const { id, title } = taskType

  const initTask = {
    order_item_id: orderItem.id,
    order_item_task_type_id: id,
    provider_id: orderItem.provider_id,
  }

  const { callbacks: { createOrEditOrderItemTask } } = useOrderItemTask(initTask)

  return (
    <SidebarModal.Button
      boxProps={{ paddingY: ['xlarge', 'large'] }}
      iconLeft={(
        <TaskIcon taskTypeId={id} />
      )}
      key={id}
      onClick={() => createOrEditOrderItemTask()}
      title={title}
    />
  )
}

export default NewTask
